import React from 'react'

import Container from "../../../node_modules/@material-ui/core/Container";
import {  useLocation  } from "react-router-dom";

import axios from 'axios';
import { trackPromise } from 'react-promise-tracker'
import {  toast } from 'react-toastify';



export default function Eticket() {
 
 
function useQuery() {
return new URLSearchParams(useLocation().search);
}




let query = useQuery();

var pureText=query.get("ref")
  

//
axios.get(`https://online-cashbox.ngrok.io/eticketpdfhtml?ref=`+pureText, {pureText})
.then(response => {
  console.log('-------------------------------------------------------------------DRANIX API CALL ONCE');
  console.log(response.data);
  
  
  toast.success('Your Request is submitted.')  //    sessionstorage.setItem('shop',shop)
 
  
  window.location.href = "https://online-cashbox.ngrok.io/eticketpdfhtml?ref="+pureText;

})
.catch(error => {

  window.location.href = "https://online-cashbox.ngrok.io/eticketpdfhtml?ref="+pureText;

});
    



    

 return (
  <Container component="main" maxWidth="xs">
  </Container>
);
}
